import { AxiosError, AxiosResponse } from "axios";
import axiosClient from "../../common/axios/axiosConfig";
import { ErrorToast } from "../../common/toasts/toasts";
import useQuery from "../../utils/useQuery";

interface IResponse {
  identifier: string;
  token: string;
}

export const getAccessToken = (): Promise<void | AxiosResponse<IResponse>> => {
  const urlSearchParams = useQuery();
  const telemedicineToken = urlSearchParams.get("token") || "";
  return axiosClient
    .get(`/room/integration`, {
      headers: {
        Authorization: `Bearer ${telemedicineToken}`,
      },
    })
    .catch((err: AxiosError) => {
      if (err.response) {
        const { status } = err.response;

        switch (status) {
          case 503:
            ErrorToast.fire({
              html: "Serviço de telemedicina temporariamente indisponível!<br/>Entre em contato com o suporte.",
              timer: 7000,
            });
            break;
          case 409:
            throw err.response;
          default:
            ErrorToast.fire({
              text: "Erro ao gerar token de acesso",
            });
            break;
        }
      } else {
        ErrorToast.fire({
          text: "Erro ao gerar token de acesso",
        });
      }
    });
};
